import React from 'react';
import "./index.css";
import "./mobile.css";

function DialogBox({ text, indexNumber, left, top, imageSource, heading, bodyButtonText, bodyImageSource,closeFunction,moveFunction,upFunction,downFunction,zIndex }) {

    const renderTextContent = () => (
        <>
            {text.split('<br>').map((segment, index, array) => (
                <React.Fragment key={index}>
                    {segment}
                    {index < array.length - 1 && <br />}
                </React.Fragment>
            ))}
            {bodyButtonText && <div className="dialog-box-button">{bodyButtonText}</div>}
        </>
    );

    const renderImageContent = () => (
        <img className="dialog-box-image" src={bodyImageSource} alt={heading} />
    );

    return (
        <div className="dialog-box" id={indexNumber} 
        style={{ left: left, 
            top: top, 
            zIndex:zIndex
        }}
        onMouseMove={moveFunction}
        onMouseUp={upFunction}
        data-boxindex={indexNumber}
        >
            <div className="dialog-box-heading big-text draggable-box"
             onMouseDown={downFunction}
             data-boxindex={indexNumber}
            >
                <div className="dialog-box-info draggable-box" data-boxindex={indexNumber}>
                    <img className="heading-image draggable-box" src={imageSource} alt="heading" data-boxindex={indexNumber}/>
                    <div className='draggable-box' data-boxindex={indexNumber}>{heading}</div>
                </div>
                <img className="close-button" src="./images/UI/close.png" alt="close button" onClick={()=>{closeFunction(indexNumber)}} />
            </div>
            <div className="dialog-box-body small-text">
            {bodyImageSource && <img className="dialog-box-image" src={bodyImageSource} alt={heading} />}
            {text && (!bodyImageSource ? renderTextContent() : <>{renderTextContent()}</>)}    
            </div>
        </div>
    );
}

export default DialogBox;
